import * as z from "zod/v4";

export const completeSelfServeOnboardingV2 = {
  name: "completeSelfServeOnboardingV2" as const,
  input: z.null(),
  output: z.null(),
};
